import React from 'react'
import { Spinner } from '@/design-system/atoms/Spinner'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  color?: 'primary' | 'brand' | 'gray'
}

const colorClasses: Record<
  NonNullable<LoadingSpinnerProps['color']>,
  string
> = {
  primary: 'text-primary-600',
  brand: 'text-brand-600',
  gray: 'text-gray-600',
}

/**
 * @deprecated Prefer `<Spinner>` do design-system direto.
 * Mantido como adapter para compat com consumers legados.
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  color = 'brand',
}) => <Spinner size={size} className={`${colorClasses[color]} ${className}`} />

// Component for typing/processing indication in chat
interface TypingIndicatorProps {
  className?: string
  message?: string
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  className = '',
  message,
}) => {
  if (message && message.trim()) {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <Spinner size="sm" className="text-brand-500 flex-shrink-0" />
        <div className="text-sm text-gray-700 dark:text-gray-300 font-medium">
          {message}
        </div>
      </div>
    )
  }

  // Classic 3-dot bouncing animation (unique — not replaced by Spinner)
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <div className="w-2 h-2 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce" />
      <div
        className="w-2 h-2 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce"
        style={{ animationDelay: '0.15s' }}
      />
      <div
        className="w-2 h-2 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce"
        style={{ animationDelay: '0.3s' }}
      />
    </div>
  )
}
